import React, { Component } from 'react';
import { connect } from 'react-redux';
import Webcam from 'react-webcam';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import { formInput, formError } from 'actions/FormActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { registerShift } from 'actions/EntityActions';
import TimerOffIcon from '@mui/icons-material/TimerOff';
import { AccessAlarmIcon } from '@mui/icons-material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ClockLive from 'screens/components/advanced/clockTime';
import DialogInput from 'screens/components/advanced/DialogInput';
import SelectInput from 'screens/components/basic/SelectInput';
import WithRouter from 'custom/withRouter';

const name = 'clockIn';
const dow = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const date = new Date();
class ClockInOutPage extends Component {
    constructor(props) {
        super(props);

        this.webcam = null;
        this.state = {
            dialogCheckClock: false,
            dialogBranchSelection: false,
            isClockIn: false
        }

        this.closeClockDialog = this.closeClockDialog.bind(this)
    }

    componentWillReceiveProps = (newProps) => {
        if (this.props.saveTimestamp !== newProps.saveTimestamp) {
            if (newProps.saveSuccess === true) {
                this.props.showSnackbar(newProps.saveSuccessMessage);
                if (this.props.cancel) {
                    this.props.cancel();
                } else {
                    this.props.navigate('/');
                }
            }
            else if (newProps.saveSuccess === false) {
                if (newProps.errorHasBranchInfo) {
                    this.setState({ dialogBranchSelection: true });
                } else {
                    this.props.showError(newProps.saveError);
                }
            }
        }
    }

    componentWillUnmount = () => {
        this.props.formInput(null, `${name}employeeNumber`);
        this.props.formInput(null, `${name}pinNumber`)
    }

    setRef = (webcam) => {
        this.webcam = webcam;
    }

    confirm = (isClockIn) => {
        this.setState({ isClockIn: isClockIn });
        let model = {
            imageBase64: null,
            employeeId: this.props.employeeId,
            isClockIn: isClockIn,
            branchId: this.props.branchId,
            pinNumber: this.props.pinNumber
        };

        if (this.props.employeeId != 0 || this.props.pinNumber != "") {
            const imageSrc = this.webcam.getScreenshot();
            model.imageBase64 = imageSrc || "";
            this.props.registerShift(model);
        } else {
            this.setState({ dialogCheckClock: true });
        }
    }

    confirmFromErrorDialog() {
        if (!this.props.clockInBranchSelection) {
            this.props.showError("Please select branch to clock in/out!");
        } else {
            const imageSrc = this.webcam.getScreenshot();
            let model = {
                imageBase64: imageSrc || "",
                employeeId: this.props.employeeId,
                isClockIn: this.state.isClockIn,
                branchId: Number(this.props.clockInBranchSelection),
                pinNumber: this.props.pinNumber
            };
            this.setState({ dialogBranchSelection: false });
            this.props.registerShift(model);
        }
    }

    closeClockDialog = () => {
        this.setState({ dialogCheckClock: false });
    }

    closeDialogBranchSelection = () => {
        this.setState({ dialogBranchSelection: false });
    }

    cancelClockIn = () => {
        if (this.props.cancel) {
            this.props.cancel();
        } else {
            this.props.navigate('/');
        }
    }

    render() {
        const p = this.props;

        let branchSelectionOptions = (p.employeeBranchesInfo || []).map(b => ({
            text: b.name,
            value: b.id.toString()
        }));

        return (
            <ContainerDivided>
                <DialogInput
                    title="Clock In/Out"
                    modal={true}
                    open={this.state.dialogBranchSelection}>
                    <p className="pa-2 text-center">Please select branch to clock in/out</p>
                    <div className="col-lg-12">
                        <SelectInput
                            name={name + "BranchSelection"}
                            fullWidth={true}
                            label={"Select Branch"}
                            floatingLabelText={"Select Branch"}
                            hintText={"Select Branch"}
                            options={branchSelectionOptions} />
                    </div>
                    <div className="col-lg-12">
                        <Button name="buttonSave"
                            className="pull-right btnNewBrandPOS"
                            label="Confirm"
                            primary={true}
                            onTouchTap={() => this.confirmFromErrorDialog()}
                        />
                        <Button
                            type="CancelButton"
                            name="buttonCancel"
                            className="pull-right btn-space btnCancelOperation"
                            label={"Cancel"}
                            onTouchTap={() => this.closeDialogBranchSelection()}
                        />
                    </div>
                </DialogInput>
                <DialogInput
                    title="Clock In/Out"
                    modal={true}
                    open={this.state.dialogCheckClock}>
                    <p className="pa-2 text-center">Please enter Employee Id or Employe Pin Number to clock in/out</p>
                    <Button
                        key={2}
                        name="buttonRemoveItem"
                        label="Confirm"
                        className="pull-right"
                        primary={true}
                        onTouchTap={() => this.closeClockDialog()}
                    />
                </DialogInput>
                <div className="container pt-4">
                    <div className="row m-0 pt-4">
                        <div className="col-lg-6 col-md-5 col-sm-12 col-xs-12">
                            <div>
                                <div className="liveClock">
                                    <h4 className="db-title">
                                        {
                                            `${dow[date.getDay()] + " " + months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`
                                        }
                                    </h4>
                                    <ClockLive />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-7 col-sm-12 col-xs-12">
                            <div className="pt-1" style={{ display: p.clockInImage ? 'none' : 'block' }}>
                                <Webcam
                                    ref={this.setRef}
                                    audio={false}
                                    height={400}
                                    width={500}
                                    screenshotFormat="image/png"
                                    style={{ margin: 'auto', display: 'block', backgroundColor: '#424242' }} />
                            </div> {/* div for webcam */}

                            <div >
                                <TextInput name={`${name}employeeNumber`} type="number" floatingLabelText="Employee Number" fullWidth={true} hintText="Employee Number" maxLength={150} />
                                <h4 className='mb-0'>Or By Pin Number</h4>
                                <TextInput name={`${name}pinNumber`} type="number" floatingLabelText="Pin Number" fullWidth={true} hintText="Pin Number" maxLength={6} />
                            </div> {/* .col for text input */}

                            <div className="row d-flex justify-content-center">
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-1 text-center">
                                    <Button
                                        type="IconInButton"
                                        label="Clock In"
                                        className="clockIn_out"
                                        style={{ width: '100%' }}
                                        backgroundColor="#4CAF50"
                                        icon={< AccessTimeIcon />}
                                        onTouchTap={() => this.confirm(true)}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-1 text-center">
                                    <Button
                                        type="IconInButton"
                                        label="Clock Out"
                                        className="clockIn_out"
                                        backgroundColor="#ff0000 "
                                        icon={<TimerOffIcon />}
                                        style={{ width: '100%' }}
                                        onTouchTap={() => this.confirm(false)} />
                                </div> {/* .col for confirm button */}
                            </div>
                            <div className="mt-4">
                                <Button
                                    type="button"
                                    label="Cancel"
                                    style={{ width: '100%' }}
                                    className="btnCleanSearch"
                                    onTouchTap={this.cancelClockIn} />
                            </div> {/* .col for text input */}
                        </div>
                    </div>
                </div>
            </ContainerDivided>
        );
    }
}


function mapStatetoProps(state) {
    return {
        clockInImage: state.form[`${name}Image`],
        employeeId: state.form[`${name}employeeNumber`] ? parseInt(state.form[`${name}employeeNumber`]) : 0,
        pinNumber: state.form[`${name}pinNumber`] ? parseInt(state.form[`${name}pinNumber`]) : 0,
        saveTimestamp: state.form[`${name}SaveTimestamp`],
        saveSuccess: state.form[`${name}SaveSuccess`],
        saveError: state.form[`${name}SaveError`],
        saveSuccessMessage: state.form[`${name}SaveSuccessMessage`],
        branchId: state.common.branchId,
        employeeBranchesInfo: state.entity.employeeBranchesInfo || [],
        errorHasBranchInfo: state.form[`${name}ErrorHasBranchInfo`],
        clockInBranchSelection: state.form[`${name}BranchSelection`],
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        formInput: (value, name) => dispatch(formInput(value, name)),
        formError: (name, error) => dispatch(formError(name, error)),
        showError: (msg) => dispatch(showError(msg)),
        showSnackbar: (msg) => dispatch(showSnackbar(msg)),
        registerShift: ({ employeeId, imageBase64, isClockIn, branchId, pinNumber }) => dispatch(registerShift(employeeId, imageBase64, name, isClockIn, branchId, pinNumber))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(ClockInOutPage));